<template>
  <div id="general_info" style="font-family:Source Sans Pro, sans-serif;overflow: visible;">
    <div class="container-fluid">
      <div class="card general_info">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="panel-heading" id="first">General Information</div>
            </div>
          </div>
          <hr style="margin-left:-1.5%;margin-right:-1.6%;" />
          <div submit="false">
            <input
              type="hidden"
              name="csrfmiddlewaretoken"
              value="4A89T1Sew8idihRP6DBtvM6mnlaFjZaXITSYv6v8YMQ5MujnNmoOkxFBIB1HNIsb"
            />
            <!-- FIRST ROW: INSPECTION TYPE -->
            <div class="row">
              <div class="col-3">
                <div class="form-group dropdown">
                  <label class="control-label">
                    Inspection type
                    <span class="important">*</span>
                  </label>
                  <dropdown
                    :optionlist="['Bulk', 'Received Packed', 'Pack Line','Shipping','Returned Product']"
                    @select="updateInspectionType"
                    class="inspection_type_input"
                    :disabled="this.noEditflag"
                    defaultValue="Type"
                    :defaultSelected="basicinfo.inspection_type"
                  />
                </div>
              </div>
            </div>
            <!-- SECOND ROW: CONSIGNMENT AND LOT DATA: CONSIGNMENT AS INPUT -->
            <div v-if="staticData.inspection_type && isInspectioForConsignment " class="row">
              <div class="col-3">
                <div class="form-group" 
                    ref="id_consignment_num"
                >
                  <label class="control-label">
                    Consignment Number
                    <span class="important">*</span>
                  </label>
                  <input
                    type="text"
                    v-if="noEditflag && basicinfo.consignment_num!=''"
                    name="consignment_num"
                    v-model="basicinfo.consignment_num"
                    :disabled="!(!this.basicinfo.consignment_num)"
                    class="form-control"
                    id="id_consignment_num"
                  />
                  <list-select
                    class="consignment_input"
                    v-else
                    :list="this.consignmentNums"
                    :value="staticData.consignment_num"
                    option-value="title"
                    option-text="title"
                    placeholder="Consignment Number"
                    id="id_consignment_number"
                    @select="getConsignmentData"
                  ></list-select>
                </div>
              </div>

              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Purchase Order</label>
                  <input
                    type="text"
                    v-if="this.noEditflag"
                    name="purchase_order"
                    v-model="basicinfo.purchase_order"
                    :disabled="true"
                    class="form-control"
                    id="id_purchase_order"
                  />
                  <!-- //!(!this.basicinfo.purchase_order) -->
                  <input
                    type="text"
                    v-else
                    name="purchase_order"
                    v-model="staticData.purchase_order"
                    disabled
                    @input="setGeneralInfo"
                    class="form-control"
                    id="id_purchase_order"
                  />
                </div>
              </div>
            </div>
            <!-- SECOND ROW: CONSIGNMENT AND LOT DATA:  LOT AS INPUT -->
            <div v-else-if="staticData.inspection_type" class="row">
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">
                    Lot Number
                    <span class="important">*</span>
                  </label>
                  <list-select
                    class="consignment_input"
                    :list="this.lotNums"
                    :value="staticData.lot_num"
                    option-value="title"
                    option-text="title"
                    placeholder="Lot Number"
                    id="id_lot_num"
                    @select="selectLotNo"
                    ref="id_lot_num"
                  ></list-select>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Consignment Number</label>
                  <!-- //!(!this.basicinfo.consignment_num) -->
                  <input
                    type="text"
                    name="consignment_num"
                    v-model="this.noEditflag?this.basicinfo.consignment_num: this.staticData.consignment_num"
                    disabled
                    class="form-control"
                    id="id_consignment_num"
                  />
                </div>
              </div>

              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Purchase Order</label>
                  <input
                    type="text"
                    name="purchase_order"
                    v-model="this.noEditflag?this.basicinfo.purchase_order: this.staticData.purchase_order"
                    disabled
                    class="form-control"
                    id="id_purchase_order"
                  />
                </div>
              </div>
            </div>
            <!-- THIRD ROW: ITEM INFO -->
            <div v-if="staticData.inspection_type" class="row">
              <div class="col-3">
                <div class="form-group dropdown">
                  <label class="control-label">
                    Item Number
                    <span class="important">*</span>
                  </label>
                  <input
                    type="text"
                    name="item_no"
                    v-if="this.noEditflag"
                    disabled
                    class="form-control"
                    v-model="basicinfo.item_no"
                    id="id_item_no"
                  />
                  <input
                    type="text"
                    name="item_no"
                    v-else-if="this.generalInfo.item_no.flag==1 ||this.noConsignmentFlag"
                    :disabled="item_no_disabled"
                    @change="getItemNumberData"
                    class="form-control"
                    v-model="staticData.item_no"
                    id="id_item_no"
                  />
                  <select
                    style="width:100%"
                    name="item_no"
                    v-else
                    v-model="staticData.item_no"
                    class="form-control item_number_input"
                    @change="selectItemNo"
                    id="select_id_item_no"
                  >
                    <option key=" " value item style="display:none;" selected hidden>Select One</option>
                    <option
                      v-for="item in this.newItemNoArr"
                      :key="item"
                      :item="item"
                    >{{item.item_no}} - {{item.item_description}}</option>
                  </select>
                </div>
              </div>

              <div class="col-3">
                <div class="form-group dropdown">
                  <label class="control-label">Production Process Code</label>
                  <input
                    type="text"
                    name="package_type"
                    disabled
                    class="form-control"
                    v-model="this.noEditflag?this.basicinfo.package_type: this.staticData.package_type"
                    id="id_package_type"
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Ordered Quantity</label>
                  <input
                    type="text"
                    name="Quantity"
                    v-model="this.noEditflag?this.basicinfo.Quantity: this.staticData.Quantity"
                    disabled
                    class="form-control"
                    id="id_Quantity"
                  />
                </div>
              </div>

              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Commodity</label>
                  <input
                    type="text"
                    name="commodity"
                    v-if="noEditflag"
                    :value="basicinfo.commodity"
                    disabled
                    class="form-control"
                    id="id_commodity"
                  />
                  <input
                    type="text"
                    name="commodity"
                    v-else
                    disabled
                    v-model="staticData.commodity"
                    @input="setGeneralInfo"
                    class="form-control"
                    id="id_commodity"
                  />
                </div>
              </div>
            </div>

            <!-- FORTH ROW: COMMODITY AND VENDOR INFO -->
            <div v-if="staticData.inspection_type" class="row">
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Variety</label>
                  <input
                    type="text"
                    name="variety"
                    v-if="this.noEditflag"
                    disabled
                    v-model="basicInfo.variety"
                    @input="setGeneralInfo"
                    class="form-control"
                    id="id_variety"
                  />
                  <!-- <select   v-else-if="this.generalInfo.variety.flag == 2" name="variety" class="form-control" id="id_variety">
                                        <option v-for="value in this.generalInfo.variety.value" :key= "value" :value="value" @select="setGeneralInfo">{{value}}</option>
                  </select>-->
                  <input
                    type="text"
                    name="variety"
                    v-else
                    disabled
                    v-model="staticData.variety"
                    @input="setGeneralInfo"
                    class="form-control"
                    id="id_variety"
                  />
                </div>
              </div>

              <div class="col-3">
                <div class="form-group dropdown">
                  <label class="control-label">
                    Vendor Number
                    <span class="important">*</span>
                  </label>
                  <input
                    type="text"
                    name="vendor_no"
                    v-if="this.noEditflag"
                    disabled
                    class="form-control"
                    v-model="basicinfo.vendor_no"
                    id="id_vendor_no"
                  />
                  <input
                    type="text"
                    name="vendor_no"
                    v-else-if="this.generalInfo.vendor_no.flag==1"
                    disabled
                    class="form-control"
                    v-model="staticData.vendor_no"
                    id="id_vendor_no"
                  />
                </div>
              </div>

              <div class="col-6">
                <div class="form-group">
                  <label class="control-label">Vendor Name</label>
                  <input
                    type="text"
                    name="grower"
                    disabled
                    v-model="this.noEditflag?this.basicinfo.grower: this.staticData.grower"
                    class="form-control"
                    id="id_grower"
                  />
                </div>
              </div>
            </div>

            <!-- FIFTH ROW: INSPECTION INFO  -->
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Inspector name</label>
                  <input
                    type="text"
                    name="inspector_name"
                    v-model="this.noEditflag?this.basicinfo.inspector_name: this.staticData.inspector_name"
                    class="form-control"
                    required
                    disabled
                    id="id_inspector_name"
                  />
                </div>
              </div>

              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Inspection date</label>
                  <div v-if="this.noEditflag" class="input-group">
                    <input
                      type="text"
                      name="inspection_date"
                      disabled
                      class="form-control"
                      v-model="basicinfo.inspection_date"
                      id="id_inspection_date"
                    />
                    <span class="input-group-addon">
                      <span
                        style="background-color: #24C656;border-top-right-radius: 4px;padding-top:10px;padding-bottom:12px;"
                      >
                        <img src="@/assets/images/cal.svg" alt style="padding: 12px 09px;" />
                      </span>
                    </span>
                  </div>

                  <Calendar
                    v-else
                    v-model="date"
                    lang="en"
                    position="bottom"
                    class="inspection-date-picker"
                    :date-format=" {day: '2-digit', month: '2-digit', year: 'numeric'}"
                  />

                  <!--<input type="text" name="inspection_date" v-model = "generalInfo.inspection_date"  @input= "setGeneralInfo" class="form-control"
                  required="" id="id_inspection_date">-->
                </div>
              </div>

              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Inspection time</label>
                  <div v-if="this.noEditflag" class="input-group">
                    <input
                      type="text"
                      name="inspection_time"
                      disabled
                      class="form-control"
                      v-model="basicinfo.inspection_time.HH+':'+this.basicinfo.inspection_time.mm"
                      id="id_inspection_time"
                    />
                    <span class="input-group-addon">
                      <span
                        style="background-color: #24C656;border-top-right-radius: 4px;padding-top:10px;padding-bottom:12px;"
                      >
                        <img src="@/assets/images/clock.svg" alt style="padding: 12px 09px;" />
                      </span>
                    </span>
                  </div>

                  <Timepicker
                    style="width:100%"
                    v-else
                    :disabled="this.noEditflag"
                    :class="this.noEditflag?'disabled':''"
                    v-model="staticData.inspection_time"
                  ></Timepicker>
                  <!--<input type="text" name="inspection_time" v-model = "generalInfo.inspection_time"  @input= "setGeneralInfo"
                  class="form-control hasWickedpicker" required="" id="id_inspection_time" onkeypress="return false;" aria-showingpicker="false" tabindex="0">-->
                </div>
              </div>

              <!--   <div class="col-3">
                                <div class="form-group">
                                    <label>Harvest date</label>
                                    <input type="text" name="harvest_date" value="01-04-2019" class="form-control" id="id_harvest_date">
                                </div>
              </div>-->
            </div>

            <!-- SIXTH ROW: ITEM DESCRIPTION -->
            <div v-if="staticData.inspection_type" class="row">
              <div class="col-6">
                <div class="form-group">
                  <label class="control-label">Item Description</label>
                  <textarea
                    name="item_description"
                    v-model="this.noEditflag?this.basicinfo.item_description: this.staticData.item_description"
                    disabled
                    class="form-control"
                    id="id_item_description"
                  />
                </div>
              </div>
            </div>

            <div id="second_heading">Lot Information</div>
            <hr />
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Trailer No</label>
                  <input
                    type="text"
                    name="trailer_no"
                    v-model="staticData.trailer_no"
                    v-if="!this.noEditflag"
                    class="form-control"
                    id="id_trailer_no"
                  />
                  <input
                    type="text"
                    name="trailer_no"
                    disabled
                    v-model="basicinfo.trailer_no"
                    v-else
                    class="form-control"
                    id="id_trailer_no"
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">Weight / Quantity Received</label>
                  <input
                    type="text"
                    name="recieved_quantity"
                    v-model="staticData.recieved_quantity"
                    v-if="!this.noEditflag"
                    class="form-control"
                    required
                    id="id_recieved_quantity"
                  />
                  <input
                    type="text"
                    name="recieved_quantity"
                    disabled
                    v-model="basicinfo.recieved_quantity"
                    v-else
                    class="form-control"
                    id="id_recieved_quantity"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <div class="form-group dropdown">
                  <label class="control-label">Measurement Unit</label>
                  <dropdown
                    :optionlist="['lb','totes','count']"
                    @select="function(item){staticData.units=item.option}"
                    :disabled="noEditflag"
                    defaultValue="Unit"
                    :defaultSelected="basicinfo.units"
                  ></dropdown>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="control-label">
                    No. of Samples
                    <span class="important">*</span>
                  </label>
                  <input
                    type="text"
                    v-if="this.noEditflag"
                    name="num_samples"
                    v-model="basicinfo.num_samples"
                    disabled
                    class="form-control"
                    id="id_num_samples"
                  />
                  <input
                    type="number"
                    v-else
                    name="num_samples"
                    v-model="staticData.num_samples"
                    @input="setSamples"
                    class="form-control my"
                    required
                    id="id_num_samples"
                    min="0"
                    max="10"
                    style="width:100%;"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col text-center">
                <input
                  type="submit"
                  class="btn btn-primaryy"
                  value="Submit"
                  :disabled="submitDisabled"
                  @click="openSamples"
                />
              </div>
            </div>

            <sweet-modal
              ref="modal"
              icon="warning"
              id="alert"
              style="background: rgba(0, 0, 0, 0.15);"
            >Item Number / Inspection Type / No. of Samples are Mandatory</sweet-modal>
            <sweet-modal
              ref="modals"
              icon="warning"
              id="alert"
              style="background: rgba(0, 0, 0, 0.15);"
            >No. of Samples must between 1 to 10</sweet-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/NewStyleSheet.css"></style>
<style>
.ui.selection.dropdown.disabled {
  border: 1px solid #323232;
  background: #e9ecef;
}
.consignment_input.ui.fluid.search.selection.dropdown {
  border-color: rgb(36, 198, 86);
}
.inspection_type_input .dropdown-wrapper {
  border-color: rgb(36, 198, 86);
}
#select_id_item_no {
  border-color: rgb(36, 198, 86) !important;
}
#id_num_samples {
  border-color: rgb(36, 198, 86) !important;
}
</style>



<script>
import { Component, Prop, Vue } from "vue-property-decorator";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vuejs-timepicker";
import datetime from "vuejs-datetimepicker";
import { ListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
//import Autocomplete from 'vuejs-auto-complete'
import { mapState, mapActions } from "vuex";
import Calendar from "./calnder.vue";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import dropdown from "@/components/dropdown/dropdown.vue";

import Timepicker from "./timepicker.vue";

@Component({
  components: {
    Datepicker,
    VueTimepicker,
    datetime,
    ListSelect,
    Calendar,
    SweetModal,
    SweetModalTab,
    Timepicker,
    dropdown,
    // Autocomplete
  },
})
@Prop({
  props: ["maximized"],
})

// const state = {
//   date1: new Date();
// };
export default class FormTemp extends Vue {
  date = new Date();
  staticData = {
    consignment_num: "",
    lot_num: "",
    purchase_order: "",
    inspection_date: this.date.toISOString().slice(0, 10),
    inspection_time: this.getTime(),
    inspector_name: this.$store.state.username,
    inspection_type: "",
    recieved_quantity: "",
    num_samples: "2",
    units: "",
    package_type: "",
    item_description: "",
    item_no: "",
    variety: "",
    grower: "",
    Quantity: "",
    vendor_no: "",
    trailer_no: "",
  };
  basicinfo = {};
  noConsignmentFlag = false;
  item_no_disabled = true;
  submitDisabled = false;
  newItemNoArr = [];

  get isInspectioForConsignment() {
    return ["Bulk", "Received Packed"].includes(
      this.staticData.inspection_type
    );
  }

  get isInspectionPackline() {
    return ["Pack Line"].includes(
      this.staticData.inspection_type
    );
  }

  get Commodity() {
    return this.$route.params.commodity;
  }
  get docId() {
    return this.$route.params.docId;
  }
  get AllowSubmit() {
    return (
      !!this.staticData.item_no &&
      !!this.staticData.num_samples &&
      !!this.staticData.inspection_type &&
      !!this.staticData.item_description
    );
  }

  get generalInfo() {
    if(typeof(this.$store.state.generalInfo.item_description.value) === 'object'){ 
      this.newItemNoArr = this.$store.state.generalInfo.item_no.value.map((item, index) => ({ item_no: item, item_description: this.$store.state.generalInfo.item_description.value[index] })) 
      return this.$store.state.generalInfo
    }
    return this.$store.state.generalInfo;
    // consolse.log(x);
  }

  get noEditflag() {
    // return this.$store.state.nonEditflag;
    return this.$route.path.includes("/edit/");
  }
  get consignmentNums() {
    let consigNum = this.$store.state.consignmentNums;
    // let arr = [{ uid: -1, title: "Not Specified" }];
    let arr = [];
    for (var i = 0; i <= consigNum.length; i++) {
      arr.push({ uid: i, title: consigNum[i] });
    }
    return arr;
  }

  get lotNums() {
    let lotNum = this.$store.state.generalInfo.lot_num.value;
    // let arr = [{ uid: -1, title: "Not Specified" }];
    let arr = [];
    if(lotNum.length === 0){
      arr.push({ uid: 0, title: 'No Records Found' });
    }else {
        for (var i = 0; i < lotNum.length; i++) {
          arr.push({ uid: i, title: lotNum[i] });
        }
    }
    return arr;
  }

  get basicInfo() {
    if (this.noEditflag) {
      // console.log(this.$store.state.reports);

      return JSON.parse(JSON.stringify(this.$store.state.reports.basicinfo));
    }
    return {};
  }

  // LifeCycle
  async mounted() {
    this.staticData.commodity = this.$route.params.commodity;
    this.$store.commit("getLotNum", []);
    if (this.noEditflag) {
      $("datepicker").css("background-color", "#E9ECEF!important");
      await this.$store.dispatch("getReportsData", this.docId);
      if (this.basicInfo.consignment_num == "") {
        await this.$store.dispatch("getConsignmentnosFromItemNo", {
          commodity: "potato",
          item_no: this.basicInfo.item_no,
        });
      }
      this.basicinfo = this.basicInfo;
      this.staticData = _.cloneDeep(this.basicInfo);
    }
  }

  async updateInspectionType(e) {
    this.staticData = {
      ...this.staticData,
      item_no: "",
      Quantity: "",
      variety: "",
      grower: "",
      item_description: "",
      package_type: "",
      purchase_order: "",
      vendor_no: "",
      lot_num: "",
      consignment_num: "",
    };
    this.staticData.inspection_type = e.option;
    if(this.isInspectionPackline){
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("getLotNumPackline", this.Commodity);
      this.$store.commit("showLoader", false);
      document.getElementById("id_lot_num").value = "";
    }
    else if (this.isInspectioForConsignment) {
      // this.$refs["id_consignment_num"].$forceUpdate()

      this.$store.commit("showLoader", true);
      await this.$store.dispatch("getConsignmentNum", this.Commodity);
      this.$store.commit("showLoader", false);
      document.getElementById("id_consignment_number").value = "";
    } else {
      // this.$refs.id_lot_num.$forceUpdate()
      await this.$store.dispatch("getLotNum", { commodity: this.Commodity });
      document.getElementById("id_lot_num").value = "";
    }
  }

  async selectItemNo(e) {
    this.$store.dispatch("showLoader", true);

    await this.$store.dispatch("getConsignmentandItemNoData", {
      consignment_num: this.staticData.consignment_num,
      item_no: this.staticData.item_no.split('-')[0].trim(),
      commodity: this.staticData.commodity,
    });
    this.staticData.purchase_order = this.generalInfo.purchase_order.value;
    this.staticData.Quantity = this.generalInfo.Quantity.value;
    this.staticData.vendor_no = this.generalInfo.vendor_no.value;
    this.staticData.commodity = this.generalInfo.commodity.value;
    this.staticData.variety = this.generalInfo.variety.value;
    this.staticData.grower = this.generalInfo.grower.value;
    this.staticData.item_description = this.generalInfo.item_description.value;
    this.staticData.package_type =
      this.generalInfo.package_type.flag == 1
        ? this.generalInfo.package_type.value
        : "";
    this.$store.dispatch("showLoader", false);
  }

  async selectLotNo(e) {
    this.staticData.lot_num = e.title;
    this.$store.dispatch("showLoader", true);
    if(this.isInspectionPackline){
       await this.$store.dispatch("getItemfromLotPackline", this.staticData.lot_num);
    }else {
      await this.$store.dispatch("getItemfromLot", this.staticData.lot_num);
    }
    this.staticData.item_no = this.generalInfo.item_no.value;
    this.staticData.Quantity = this.generalInfo.Quantity.value;
    this.staticData.vendor_no = this.generalInfo.vendor_no.value;
    this.staticData.commodity = this.generalInfo.commodity.value;
    this.staticData.variety = this.generalInfo.variety.value;
    this.staticData.grower = this.generalInfo.grower.value;
    this.staticData.item_description = this.generalInfo.item_description.value;
    this.staticData.purchase_order = this.generalInfo.purchase_order.value;
    this.staticData.package_type = this.generalInfo.package_type.value;
    if (!this.isInspectioForConsignment) {
      this.staticData.consignment_num = this.generalInfo.consignment_num.value;
    }
    this.$store.dispatch("showLoader", false);
  }

  async getItemNumberData() {
    this.$store.dispatch("showLoader", true);
    try {
      await this.$store.dispatch("getItemNumberData", {
        item_no: this.staticData.item_no,
      });
      // this.staticData.Quantity = this.generalInfo.Quantity.value;
      this.staticData.commodity = this.generalInfo.commodity.value;
      this.staticData.variety = this.generalInfo.variety.value;
      // this.staticData.grower = this.generalInfo.grower.value;
      this.staticData.item_description = this.generalInfo.item_description.value;
      this.staticData.package_type =
        this.generalInfo.package_type.flag == 1
          ? this.generalInfo.package_type.value
          : "";
    } catch (err) {
      this.staticData.variety = "";
      // this.staticData.grower = this.generalInfo.grower.value;
      this.staticData.item_description = "";
      this.staticData.package_type = "";
      this.staticData.item_no = "";
    } finally {
    this.$store.dispatch("showLoader", false);
    }
  }
  getTime() {
    var hour = new Date().getHours();
    var minutes = new Date().getMinutes();
    return { HH: hour, mm: minutes < 10 ? "0" + minutes : minutes };
  }
  setGeneralInfo(e) {
    this.staticData[e.target.name] = e.target.value;
  }
  async getCompleteData() {
    await this.$store.dispatch("getConsignmentandItemNoData", {
      consignment_num: this.basicinfo.consignment_num,
      item_no: this.basicinfo.item_no,
      commodity: this.basicinfo.commodity,
    });
    // console.log(this.generalInfo);

    this.basicinfo.purchase_order = this.generalInfo.purchase_order.value;
    this.basicinfo.Quantity = this.generalInfo.Quantity.value;
    this.basicinfo.vendor_no = this.generalInfo.vendor_no.value;
    this.basicinfo.grower = this.generalInfo.grower.value;
  }
  async getConsignmentData(e) {
    this.staticData = {
      ...this.staticData,
      item_no: "",
      Quantity: "",
      variety: "",
      grower: "",
      item_description: "",
      package_type: "",
      purchase_order: "",
      vendor_no: "",
      lot_num: "",
    };
    if (e.uid == -1) {
      this.noConsignmentFlag = true;
      this.item_no_disabled = false;
    } else {
    this.$store.dispatch("showLoader", true);
      this.noConsignmentFlag = false;
      this.ord_qty_disabled = true;
      this.staticData.consignment_num = e.title;
      await this.$store.dispatch("getConsignmentData", {consignment_num:e.title,commodity:this.staticData.commodity});
      if (this.generalInfo.item_no.flag == 1) {
        this.staticData.item_no = this.generalInfo.item_no.value;
        this.item_no_disabled = true;
        await this.$store.dispatch("getConsignmentandItemNoData", {
          consignment_num: this.staticData.consignment_num,
          item_no: this.staticData.item_no,
          commodity: this.staticData.commodity
        });
        this.staticData.purchase_order = this.generalInfo.purchase_order.value;
        this.staticData.Quantity = this.generalInfo.Quantity.value;
        this.staticData.vendor_no = this.generalInfo.vendor_no.value;
        this.staticData.commodity = this.generalInfo.commodity.value;
        this.staticData.grower = this.generalInfo.grower.value;
        this.staticData.item_description = this.generalInfo.item_description.value;
        this.staticData.variety = this.generalInfo.variety.value;
        this.staticData.package_type =
          this.generalInfo.package_type.flag == 1
            ? this.generalInfo.package_type.value
            : "";
        }
    }
    this.$store.dispatch("showLoader", false);

  }

  convert() {
    var date = this.date.toISOString().slice(0, 10);
    // console.log(date)
    var year = date.slice(0, 4);
    var month = date.slice(5, 7);
    var day = date.slice(8, 10);
    // console.log(month+"-"+day+"-"+year)
    return month + "-" + day + "-" + year;
  }
  setGeneralInfoWeight(e) {
    var samples = Math.round(parseInt(e.target.value) * 0.01);
    if (samples == 0) {
      this.staticData.num_samples = 1;
    } else {
      this.staticData.num_samples = samples;
    }
  }
  setSamples(e) {
    async (e) => {
      await this.$store.dispatch("samplesNum", e.target.value);
    };
  }

  async openSamples() {
    this.submitDisabled = true;
    this.$store.commit("setUpdateMode", false);
    if (!this.noEditflag) {
      if (this.AllowSubmit) {
        // if (this.staticData.num_samples > 10) {
        // } else {
        //   if (this.noConsignmentFlag) {
        //     this.staticData.consignment_num = "";
        //   }
        //   this.staticData.report_status = false;
        //   this.$store.dispatch("updateGeneralInfo", this.staticData);
        //   this.$store.dispatch("showNonEditableSamples", false);
        // }
        // console.log(this.staticData.num_samples);

        if (
          this.staticData.num_samples > 10 ||
          this.staticData.num_samples == 0
        ) {
          this.$store.dispatch("showSnackbar", {
            msg: "No. of Samples must not exceed 10",
          });
        } else {
          if (this.noConsignmentFlag) {
            this.staticData.consignment_num = "";
          }
          // if (this.staticData.commodity.toLowerCase() == "onion") {
          var staticData = {
            ...this.staticData,
            ordered_quantity: this.staticData.Quantity,
            inspection_time: new Date(
              this.staticData.inspection_date +
                " " +
                this.staticData.inspection_time.HH +
                ":" +
                this.staticData.inspection_time.mm
            ),
            recieved_quantity: this.staticData.recieved_quantity,
          };
          this.$store
            .dispatch("saveGeneralInfo", {
              commodity: this.Commodity,
              data: staticData,
            })
            .then(() => {
              var docId = this.$store.state.docId;
              this.$store.commit("setActiveTab", 1);
              this.$store.commit("resetSamples", this.staticData.num_samples);
              this.$store.dispatch("showNonEditableSamples", false);
              this.$router.push(
                `/app/secure/inspectionTemplate/samples/${this.Commodity}/${docId}/1`
              );
            });

          this.$store.dispatch("showLoader", false);
          this.submitDisabled = true;
          // }
          //  else {
          //   this.staticData.report_status = false;
          //   this.staticData.inspection_date = this.convert();
          //   this.$store.commit("setActiveTab", 1);
          //   this.$store.commit("resetSamples", this.staticData.num_samples);
          //   this.staticData["userComments"] = {
          //     flag: false,
          //     values: []
          //   };
          //   var LogData = this.createLogData(this.staticData, "create");

          //   this.$store
          //     .dispatch("updateGeneralInfo", this.staticData)
          //     .then(async () => {
          //       var docId = this.$store.state.docId;
          //       LogData.record = docId;
          //       await this.$store.dispatch("AddUserLog", LogData);
          //       for (
          //         var test = parseInt(this.staticData.num_samples);
          //         test > 0;
          //         test--
          //       ) {
          //         //  console.log(test)]
          //         this.$store.dispatch("basicSave", {
          //           basicRequirements: this.basicRequirements,
          //           sampleno: test
          //         });
          //       }
          //       this.$store.dispatch("showNonEditableSamples", false);
          //       this.$router.push(
          //         `/app/secure/inspectionTemplate/samples/${this.Commodity}/${docId}/1`
          //       );
          //       // this.$router.go()
          //       // this.submitDisabled=false
          //     });
          // }
        }
      } else {
        //   alert("Item Number, Inspection Type and No. of Samples is Mandatory");
        this.$store.dispatch("showSnackbar", {
          msg: "Item Number, Inspection Type and No. of Samples is Mandatory",
        });
      }
    } else {
      var data = this.basicinfo;
      delete data.user;
      delete data.created;
      var LogData = this.createLogData(data, "edit");

      this.$store.dispatch("editGeneralInfo", data).then(async () => {
        await this.$store.dispatch("AddUserLog", LogData);
        await this.$store.dispatch("getReportsData", this.docId);
        // this.$store.dispatch("showReport");
        // if(this.userType=='manager'){
        this.$router.push(
          `/app/secure/inspectionSummary/edit/samples/${this.Commodity.toLowerCase()}/${
            this.docId
          }/1`
        );
        // }
        // else{
        // console.log(this.$router);

        // this.$router.push(`/app/secure/inspectionSummary/report/${this.Commodity.toLowerCase()}/${this.docId}`);
        // }
        this.submitDisabled = false;
      });
    }
    this.submitDisabled = false;
    this.$store.commit("resetSavedTabs");
  }
  // Application Logs
  createLogData(obj, mode) {
    var generalInfo = _.cloneDeep(obj);
    var keys = [],
      oldValue = [],
      newValue = [];
    var LogData = {};
    if (mode == "edit") {
      delete generalInfo.inspection_time;
      for (let key in generalInfo) {
        if (generalInfo[key] !== this.staticData[key]) {
          newValue.push(generalInfo[key]);
          oldValue.push(this.staticData[key]);
          keys.push(key);
        }
      }
      LogData = {
        user: this.$store.state.username,
        collection: "inspectionReport",
        mode: "edit",
        record: this.docId,
        fields: keys,
        newValue,
        oldValue,
      };
    } else if (mode == "create") {
      delete generalInfo.report_status, generalInfo.userComments;
      LogData = {
        user: this.$store.state.username,
        collection: "inspectionReport",
        mode: "create",
        fields: [],
        newValue: [],
        oldValue: [],
      };
    }
    // console.log(x`LogData);

    return LogData;
  }

  // LifeCycle
  async created() {
    this.$store.commit("changePathLabel", {
      view: "Create Inspection",
      categories: [
        { name: "General Inspection", focus: true },
        { name: "Sample Inspection", focus: false },
        { name: "Preview", focus: false },
        { name: "Report", focus: false },
      ],
    });
    this.$store.dispatch("showNonEditableSamples", this.noEditflag);

    this.$store.dispatch("showLoader", false);
  }
}
// data () {
//       return {
//         template : false
//       }

// }
</script>
<style scoped>
.control-label {
  color: #858585;
}
.my::-webkit-outer-spin-button,
.my::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

.card.general_info {
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
}
textarea {
  resize: none;
}
.my {
  -moz-appearance: textfield; /* Firefox */
}

.dropdown select {
  /*border: 0 !important;  */ /*Removes border*/
  -webkit-appearance: none; /*Removes default chrome and safari style*/
  -moz-appearance: none; /* Removes Default Firefox style*/
  background: url("../assets/images/arrow.svg") no-repeat; /*Adds background-image*/
  background-position: 96%; /*Position of the background-image*/
  width: 100px; /*Width of select dropdown to give space for arrow image*/
}
hr {
  color: #cacaca;
  height: 1px;
}

input:disabled {
  background: #fbfbfb !important;
}
.form-control {
  height: 38px !important;
  border: 1px solid #b4b4b4 !important;
}
</style>

<link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro&display=swap" rel="stylesheet">
<script type="text/javascript">
$(function () {
  $("#datetimepicker3").datetimepicker({
    format: "LT",
  });
});
$(function () {
  $("#datetimepicker1").datetimepicker();
});
$(function () {
  $("#datetimepicker3").datetimepicker({
    format: "LT",
  });
});
</script>
